
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr",
      function () {
        return require("private-next-pages/fr/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr"])
      });
    }
  